/**
 * Client-side twin of the database's cat_norm(): the folding the MR "Browse catalog" search uses.
 * lower-case · alef variants → ا · ة → ه · ى → ي · ؤ → و · ئ → ي · Persian ک/ی/ۀ → ك/ي/ه · Arabic-Indic and
 * Persian digits → 0-9 · hamza dropped · tashkeel and tatweel removed · spaces, hyphens, underscores removed,
 * so "ازم" finds "أزمير" and "f s sat" finds "F-S-SAT-…".
 */
const FROM = 'أإآٱةىؤئکیۀ٠١٢٣٤٥٦٧٨٩۰۱۲۳۴۵۶۷۸۹ء';
const TO = 'ااااهيويكيه01234567890123456789';
const MAP: Record<string, string> = {};
for (let i = 0; i < FROM.length; i++) MAP[FROM[i]] = TO[i] ?? '';

export function catNorm(text?: string | null): string {
  if (!text) return '';
  let out = '';
  for (const ch of text.toLowerCase()) out += ch in MAP ? MAP[ch] : ch;
  return out.replace(/[ً-ْـ]/g, '').replace(/[\s\-_]+/g, '');
}

/** Every whitespace-separated token of the query must appear in the folded haystack. */
export function catMatches(query: string, ...fields: Array<string | null | undefined>): boolean {
  const tokens = query.split(/\s+/).map(catNorm).filter(Boolean);
  if (tokens.length === 0) return true;
  const hay = catNorm(fields.filter(Boolean).join(' '));
  return tokens.every((t) => hay.indexOf(t) >= 0);
}
